import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '../../../../services/rest/rest.service';
import { Agreement } from './agreement.domain';

@Injectable()
export class ConsolidatedAgreementsRestService {
  constructor(private restService: RestService) {}

  saveAgreements(agreementsInfo: Array<Agreement>): Observable<void> {
    return this.restService.getResource('agreements_v2.update').put(agreementsInfo);
  }
}

